import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitogoacab() {



    const cardData = {

keyword: "Mumbai to Goa Cabs",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Goa Cabs for family vacations, beach holidays, corporate travel, honeymoon trips, and group tours. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a smooth long-distance journey. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip cab bookings, customized sightseeing plans, 24/7 customer support, and transparent pricing, we ensure a hassle-free and memorable road trip to Goa, one of India's most popular holiday destinations.",

topPlaces: [
    {
        title: "Calangute Beach",
        description:
            "Calangute Beach is one of the largest and most famous beaches in Goa, attracting visitors with its golden sands, vibrant atmosphere, and exciting water sports. Tourists can enjoy parasailing, jet skiing, beachside cafes, seafood restaurants, and lively markets. The beach is ideal for families, couples, and groups looking for relaxation as well as adventure during their Goa vacation."
    },
    {
        title: "Baga Beach",
        description:
            "Baga Beach is well known for its energetic nightlife, beach shacks, water activities, and entertainment options. Visitors can experience banana boat rides, dolphin tours, live music, and delicious Goan cuisine while enjoying the beautiful Arabian Sea coastline. It is one of the most popular destinations for tourists visiting Goa from Mumbai."
    },
    {
        title: "Fort Aguada",
        description:
            "Fort Aguada is a seventeenth-century Portuguese fort overlooking the Arabian Sea and is one of Goa's most iconic historical landmarks. The fort features a historic lighthouse, impressive stone walls, and spectacular coastal views. History enthusiasts and photographers enjoy exploring this well-preserved monument while learning about Goa's colonial heritage."
    },
    {
        title: "Basilica of Bom Jesus",
        description:
            "The Basilica of Bom Jesus is a UNESCO World Heritage Site and one of the most important churches in India. It houses the sacred remains of Saint Francis Xavier and showcases magnificent Baroque architecture. Visitors from around the world come to admire its historical significance, artistic interiors, and peaceful spiritual atmosphere."
    },
    {
        title: "Dudhsagar Waterfalls",
        description:
            "Dudhsagar Waterfalls is one of India's tallest and most spectacular waterfalls, surrounded by lush forests and the Western Ghats. The cascading white waters create a breathtaking natural sight, especially during the monsoon season. Adventure lovers enjoy jeep safaris and trekking routes leading to this famous attraction."
    },
    {
        title: "Anjuna Beach",
        description:
            "Anjuna Beach is famous for its scenic beauty, rocky shoreline, flea market, and vibrant nightlife. Visitors can shop for handicrafts, enjoy beachside cafes, participate in water sports, and witness stunning sunsets over the Arabian Sea. It is a favorite destination for both domestic and international tourists."
    },
    {
        title: "Chapora Fort",
        description:
            "Chapora Fort stands on a hill overlooking the Arabian Sea and offers panoramic views of Vagator Beach and the surrounding coastline. The fort gained popularity through Bollywood and remains a favorite destination for sightseeing and photography. Its peaceful surroundings and historical significance make it a must-visit attraction."
    },
    {
        title: "Colva Beach",
        description:
            "Colva Beach is one of South Goa's most beautiful beaches, known for its long stretch of white sand, coconut trees, and peaceful environment. Visitors can enjoy swimming, water sports, beach walks, and local seafood while experiencing a quieter side of Goa away from crowded tourist areas."
    },
    {
        title: "Mangueshi Temple",
        description:
            "Mangueshi Temple is one of the most revered Hindu temples in Goa, dedicated to Lord Shiva. The temple is admired for its elegant architecture, beautiful surroundings, and spiritual significance. Pilgrims and tourists alike visit this sacred place to experience Goa's rich cultural and religious heritage."
    },
    {
        title: "Panaji City & Miramar Beach",
        description:
            "Panaji, the capital of Goa, combines Portuguese architecture, colorful streets, riverfront attractions, and modern city life. Visitors can explore Fontainhas, local markets, casinos, churches, and Miramar Beach while enjoying Goan culture and cuisine. It serves as an excellent destination for sightseeing and leisurely exploration during a Mumbai to Goa cab journey."
    }
],



services: [
{
name: "Mumbai to Goa Cab",
description: "Mumbai Airport Cab provides Mumbai to Goa Cab service for comfortable and affordable outstation travel. Travel in AC Sedan, SUV, Ertiga, Innova Crysta, and premium vehicles with experienced chauffeurs for family vacations, business trips, beach holidays, and group tours. We offer doorstep pickup, flexible schedules, one way and round trip options, transparent pricing, and 24x7 customer support for a safe and enjoyable journey."
},
{
name: "Mumbai to Goa Car Rental",
description: "Book Mumbai to Goa Car Rental with Mumbai Airport Cab for a private and convenient travel experience. Our well-maintained fleet includes economical and luxury vehicles suitable for families, couples, and corporate travelers with customized travel plans."
},
{
name: "Mumbai to Goa Taxi Fare",
description: "Get affordable Mumbai to Goa Taxi Fare with Mumbai Airport Cab. We provide transparent pricing, fixed packages, and comfortable AC vehicles without hidden charges for one way and round trip travel."
},
{
name: "Mumbai to Goa Taxi",
description: "Mumbai Airport Cab offers Mumbai to Goa Taxi service with professional drivers and clean vehicles for safe and stress-free long-distance travel across Maharashtra and Goa."
},
{
name: "Mumbai to Goa Cab Fare",
description: "Check Mumbai to Goa Cab Fare with Mumbai Airport Cab for budget-friendly and premium travel packages designed to suit every type of traveler."
},
{
name: "Mumbai to Goa Taxi One Way Fare",
description: "Book Mumbai to Goa Taxi One Way Fare service with Mumbai Airport Cab for economical drop-only travel with reliable drivers and comfortable vehicles."
},
{
name: "Mumbai to Goa Cab Price",
description: "Mumbai Airport Cab offers competitive Mumbai to Goa Cab Price with flexible vehicle options including Sedan, SUV, Ertiga, and Innova Crysta for all travel needs."
},
{
name: "Mumbai to Goa By Car Fare",
description: "Plan your journey with Mumbai to Goa By Car Fare packages from Mumbai Airport Cab and enjoy convenient travel with transparent rates and quality service."
},
{
name: "Book Cab from Mumbai to Goa",
description: "Book Cab from Mumbai to Goa instantly with Mumbai Airport Cab and enjoy easy reservations, multiple vehicle choices, and professional travel assistance."
},
{
name: "Car Hire from Mumbai to Goa",
description: "Mumbai Airport Cab provides Car Hire from Mumbai to Goa with experienced chauffeurs, comfortable seating, and flexible travel itineraries for a memorable road trip."
},
{
name: "Car on Rent from Mumbai to Goa",
description: "Hire a Car on Rent from Mumbai to Goa with Mumbai Airport Cab for family holidays, weekend getaways, and business travel with safe and reliable transportation."
},
{
name: "Mumbai Goa Cab Service",
description: "Mumbai Airport Cab offers Mumbai Goa Cab Service with premium vehicles, skilled drivers, and personalized travel plans for one way and round trip journeys."
},
{
name: "Mumbai to Goa By Road Taxi Fare",
description: "Get the best Mumbai to Goa By Road Taxi Fare with Mumbai Airport Cab and enjoy comfortable travel at affordable prices with no hidden costs."
},
{
name: "Mumbai to Goa Cab Booking",
description: "Mumbai Airport Cab provides Mumbai to Goa Cab Booking with instant confirmation, flexible pickup points, and 24x7 customer support for hassle-free travel."
},
{
name: "Mumbai to Goa Cab Booking Price",
description: "Check Mumbai to Goa Cab Booking Price with Mumbai Airport Cab for affordable travel packages and premium service for individuals, families, and groups."
},
{
name: "Mumbai to Goa Cab Charges",
description: "Mumbai Airport Cab offers transparent Mumbai to Goa Cab Charges with competitive pricing and high-quality vehicles for a comfortable journey."
},
{
name: "Mumbai to Goa Cab Hire",
description: "Book Mumbai to Goa Cab Hire with Mumbai Airport Cab for private travel in Sedan, SUV, Ertiga, and Innova Crysta vehicles with experienced chauffeurs."
},
{
name: "Mumbai to Goa Cab Rates",
description: "Get the best Mumbai to Goa Cab Rates with Mumbai Airport Cab and enjoy affordable outstation travel with safe, clean, and comfortable vehicles."
},
{
name: "Mumbai to Goa Cab Service",
description: "Mumbai Airport Cab provides Mumbai to Goa Cab Service with reliable transportation, flexible travel schedules, and premium vehicle options for every budget."
},
{
name: "Mumbai to Goa Cab Service Fare",
description: "Check Mumbai to Goa Cab Service Fare with Mumbai Airport Cab for cost-effective travel packages and transparent pricing for one way and round trips."
},
{
name: "Mumbai to Goa Car Booking",
description: "Book Mumbai to Goa Car Booking with Mumbai Airport Cab for convenient travel with a wide range of AC vehicles and professional drivers."
},
{
name: "Mumbai to Goa Car Hire",
description: "Mumbai Airport Cab offers Mumbai to Goa Car Hire for private road trips with comfortable seating, spacious luggage capacity, and flexible travel plans."
},
{
name: "Mumbai to Goa Car Rental with Driver",
description: "Choose Mumbai to Goa Car Rental with Driver from Mumbai Airport Cab for a relaxing journey with experienced chauffeurs and premium travel comfort."
},
{
name: "Mumbai to Goa Car Service",
description: "Mumbai Airport Cab provides Mumbai to Goa Car Service for holiday travel, business trips, and family vacations with safe and dependable transportation."
},
{
name: "Mumbai to Goa One Way Cab",
description: "Book Mumbai to Goa One Way Cab with Mumbai Airport Cab for affordable drop-only travel with clean AC vehicles, professional drivers, and doorstep service."
},
{
name: "Mumbai to Goa One Way Taxi",
description: "Mumbai Airport Cab offers Mumbai to Goa One Way Taxi service with flexible pickup and drop locations for comfortable and budget-friendly travel."
},
{
name: "Mumbai to Goa Taxi Price",
description: "Get the best Mumbai to Goa Taxi Price with Mumbai Airport Cab and enjoy premium travel services, transparent billing, and comfortable long-distance transportation."
}
],

tableData: [
["Mumbai to Goa Cab","Mumbai to Goa Car Rental"],
["Mumbai to Goa Taxi Fare","Mumbai to Goa Taxi"],
["Mumbai to Goa Cab Fare","Mumbai to Goa Taxi One Way Fare"],
["Mumbai to Goa Cab Price","Mumbai to Goa By Car Fare"],
["Book Cab from Mumbai to Goa","Car Hire from Mumbai to Goa"],
["Car on Rent from Mumbai to Goa","Mumbai Goa Cab Service"],
["Mumbai to Goa By Road Taxi Fare","Mumbai to Goa Cab Booking"],
["Mumbai to Goa Cab Booking Price","Mumbai to Goa Cab Charges"],
["Mumbai to Goa Cab Hire","Mumbai to Goa Cab Rates"],
["Mumbai to Goa Cab Service","Mumbai to Goa Cab Service Fare"],
["Mumbai to Goa Car Booking","Mumbai to Goa Car Hire"],
["Mumbai to Goa Car Rental with Driver","Mumbai to Goa Car Service"],
["Mumbai to Goa One Way Cab","Mumbai to Goa One Way Taxi"],
["Mumbai to Goa Taxi Price",""]
],




whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Goa Cab Service",
WhyChoosedescription: "Mumbai Airport Cab Service offers dependable Mumbai to Goa Cabs for family vacations, beach holidays, corporate trips, honeymoon tours, and group travel throughout the year."
},
{
WhyChooseheading: "Comfortable Long-Distance Journey",
WhyChoosedescription: "Travel comfortably from Mumbai to Goa with clean vehicles, spacious seating, and experienced drivers who ensure a smooth travel experience."
},
{
WhyChooseheading: "Ideal for Family and Holiday Travel",
WhyChoosedescription: "Goa is one of India's most popular tourist destinations, and our cab service is perfect for family vacations, weekend getaways, and leisure trips."
},
{
WhyChooseheading: "Wide Range of Vehicle Options",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on passenger count and travel preferences."
},
{
WhyChooseheading: "One-Way and Round Trip Facilities",
WhyChoosedescription: "Whether you require a one-way drop, return journey, multi-day vacation package, or customized itinerary, we provide flexible booking solutions."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
},
{
WhyChooseheading: "Safe and Professional Drivers",
WhyChoosedescription: "Our skilled drivers and regularly maintained vehicles ensure a safe, comfortable, and stress-free journey from Mumbai to Goa."
},
{
WhyChooseheading: "Suitable for Groups and Corporate Tours",
WhyChoosedescription: "From solo travelers to large groups, we offer suitable transportation solutions for vacations, destination events, and corporate outings."
}
]
};

const faqData = [
{
question: "Why do travelers prefer Mumbai to Goa Cabs?",
answer: "Many travelers choose cabs because they offer flexibility, privacy, comfort, and direct transportation between Mumbai and Goa."
},
{
question: "Can I book a one-way cab from Mumbai to Goa?",
answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
},
{
question: "Which vehicle is suitable for Mumbai to Goa travel?",
answer: "Sedan cars, Ertiga, Innova Crysta, and SUVs are popular options for comfortable long-distance travel."
},
{
question: "Do you provide Tempo Travellers for Goa group trips?",
answer: "Yes, Tempo Travellers are available for family vacations, corporate tours, and large group travel."
},
{
question: "Can families use this service for Goa vacations?",
answer: "Yes, our Mumbai to Goa Cab Service is highly preferred by families, couples, and tourists visiting Goa."
},
{
question: "Are airport pickups available in Mumbai?",
answer: "Yes, pickup services are available from Mumbai Airport, railway stations, hotels, offices, and residential locations."
},
{
question: "Can sightseeing stops be added during the trip?",
answer: "Yes, customers can customize their route and include sightseeing locations, meal breaks, and personal stops."
},
{
question: "Is advance booking recommended for Goa travel?",
answer: "Yes, advance booking helps secure preferred vehicles and ensures better travel planning."
},
{
question: "Do you provide round-trip packages for Goa?",
answer: "Yes, round-trip and multi-day Goa travel packages are available according to customer requirements."
},
{
question: "How can I book a Mumbai to Goa Cab?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cab Service."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Sameer Kulkarni",
feedback:
"Our family trip from Mumbai to Goa was excellent with Mumbai Airport Cab Service. The vehicle was comfortable, the driver was professional, and the journey was very enjoyable.",
rating: 5
},
{
id: 2,
name: "Mrs. Priya Shah",
feedback:
"We booked a Mumbai to Goa Cab for a holiday trip and received outstanding service. The cab was clean, punctual, and made our Goa vacation completely stress-free.",
rating: 5
}
];

























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Goa Cabs",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-goa-cab.jpg",
"description": "Book Mumbai to Goa cab service for a safe, comfortable, and affordable road trip. Mumbai Airport Cabs provides reliable taxi service with professional drivers, clean vehicles, transparent pricing, and convenient one-way and round-trip travel options.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-goa-cabs"
}
};





    return (
        <div>


<Helmet>
  <title>Mumbai to Goa Cabs | One Way Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Goa cab service at affordable fares. Reliable taxi service with professional drivers, one-way and round-trip options, comfortable cars, and hassle-free road travel from Mumbai to Goa."
/>

<meta
 name="keywords"
 content="mumbai to goa cab, mumbai to goa car rental, mumbai to goa taxi fare, mumbai to goa taxi, mumbai to goa cab fare, mumbai to goa taxi one way fare, mumbai to goa cab price, mumbai to goa by car fare, book cab from mumbai to goa, car hire from mumbai to goa, car on rent from mumbai to goa, mumbai goa cab service, mumbai to goa by road taxi, one way cab mumbai to goa, round trip taxi mumbai to goa"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/112.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitogoacab;